import * as yup from "yup";

export const schema = yup.object().shape({
  name: yup.string().trim().required("Field required").max(50, "Must be 50 characters or less"),
  subject: yup
    .string()
    .trim()
    .required("Field required")
    .max(50, "Must be 50 characters or less"),
  body: yup
    .string()
    .trim()
    .required("Field required")
    .max(150, "Must be 150 characters or less"),
  hyperlink: yup.string().test("hyperlink-test", "Invalid hyperlink", (value) => {
    if (!value || yup.string().url().isValidSync(value)) return true;
    // check relative path since yup url only allows absolute paths
    const regex = /^(\/|\.\/|\.\.\/)(.*)$/;
    return regex.test(value);
  }),
  audience: yup.string().oneOf(["all", "select"]).required("Field required"),
  isObjectLevelBasicPermissionRole: yup.boolean(),
  isManageAdminConfigurationSettingRole: yup.boolean(),
  isManageStaffAccessSettingRole: yup.boolean(),
  isManageBasicSettingRole: yup.boolean(),
  investorManagerPrivileged: yup.boolean(),
  paymentAdmin: yup.boolean(),
  paymentManager: yup.boolean(),
  investorManagerPrivilegedViewonly: yup.boolean(),
  manageportalsettings: yup.boolean(),
  managegeneralsubscriptionsettings: yup.boolean(),
  managestaffaccess: yup.boolean(),
  manageuserroles: yup.boolean(),
  manageauthentication: yup.boolean(),
  manageagreements: yup.boolean(),
  managedatafields: yup.boolean(),
  accessauditlog: yup.boolean(),
  // expiry date cannot be in the past and is nullable
  expiryDate: yup
    .string()
    .test("expiry-date", "Expiry date cannot be in the past", (value) => {
      if (!value) return true;
      const date = new Date(value);

      // normalize the date to the start of the day
      const normalizedNow = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      );
      return date >= normalizedNow;
    })
    .nullable(),
  isTestAnnouncement: yup.boolean(),
});
